import React from 'react';

import { AutocompleteState } from 'component/Layout/Autocomplete/types';

import classNames from 'classnames';

import Autocomplete from './__context';
import { useDestinationApi } from './__hooks/useDestinationApi';
import Search from './Search';
import { AutocompleterGroup, DestinationEntry, SearchProps } from './types';

import styles from './Destination.module.scss';

const Destination = ({
    destinationValue,
    onValueChange,
    onEmptyDestinationClick,
    placeholder,
    label,
    customClassList,
}: SearchProps) => {
    const { searchResultProvider } = useDestinationApi();
    const initialDestinationState: AutocompleteState<
        AutocompleterGroup,
        DestinationEntry
    > = {
        config: {
            threshold: 2,
            searchResultProvider,
        },
        currentValue: new Set(),
        recentValue: new Set(),
        results: [],
    };

    return (
        <Autocomplete initialState={initialDestinationState}>
            <Search
                customClassList={{
                    Input: classNames(styles.Input, customClassList?.Input),
                    Label: customClassList?.Label,
                    InputWrapper: customClassList?.InputWrapper,
                    Layer: customClassList?.Layer,
                }}
                destinationValue={destinationValue}
                onValueChange={onValueChange}
                onEmptyDestinationClick={onEmptyDestinationClick}
                placeholder={placeholder}
                label={label}
            />
        </Autocomplete>
    );
};

export default Destination;
